import React from 'react';

const ProductInfo = () => {
  return (
    <div>
      <h2>产品说明</h2>
      <p>这里将是产品说明内容的展示。</p>
    </div>
  );
};

export default ProductInfo;
